<header class="hd">
  <button type="button" class="hd__icon hd__menu" [attr.aria-label]="'shell.openMenu' | transloco" (click)="openMenu()">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path [attr.d]="icon.menu"></path></svg>
  </button>

  <div class="hd__search" role="search">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.search"></path></svg>
    <input #search type="search" class="hd__input" autocomplete="off" [(ngModel)]="query" [placeholder]="'shell.search.short' | transloco" [attr.aria-label]="'shell.search.label' | transloco"
      [title]="'shell.search.placeholder' | transloco" (keydown.enter)="find()" (keydown.escape)="clearSearch()">
    <kbd class="hd__kbd">{{ searchKey }}</kbd>
  </div>

  <span class="hd__spacer"></span>

  <span class="hd__clock">
    <b>{{ time }}</b>
    <span>{{ date }}</span>
  </span>

  <span *ngIf="!isProd" class="hd__test" [title]="'site.is.test' | transloco">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.flask"></path></svg>
    <span>{{ 'site.is.test' | transloco }}</span>
  </span>

  <button type="button" class="hd__number" [class.is-none]="!slot && !idsLoading" [class.is-loading]="idsLoading" [title]="'shell.number.change' | transloco" (click)="openNumber()">
    <span class="hd__number-icon" aria-hidden="true">
      <span *ngIf="idsLoading" class="hd__spin"></span>
      <svg *ngIf="!idsLoading && !slot" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.alert"></path></svg>
      <svg *ngIf="!idsLoading && slot" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.phone"></path></svg>
    </span>
    <span class="hd__number-text">
      <span>{{ 'shell.number.label' | transloco }}</span>
      <b *ngIf="idsLoading">{{ 'shell.number.loading' | transloco }}</b>
      <b *ngIf="!idsLoading && slot" class="hd__num">{{ slot }}</b>
      <b *ngIf="!idsLoading && !slot">{{ 'shell.number.none' | transloco }}</b>
    </span>
    <svg class="hd__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.down"></path></svg>
  </button>

  <span class="hd__lang" role="group" [attr.aria-label]="'shell.lang.label' | transloco">
    <button *ngFor="let l of langs" type="button" [class.is-on]="l === lang" [attr.aria-pressed]="l === lang" (click)="setLang(l)">{{ 'shell.lang.' + l | transloco }}</button>
  </span>

  <div class="hd__theme">
    <button type="button" class="hd__icon" aria-haspopup="menu" [class.is-open]="themeMenu" [attr.aria-expanded]="themeMenu"
      [title]="'shell.theme.label' | transloco: { name: ('shell.theme.' + mode | transloco) }" [attr.aria-label]="'shell.theme.label' | transloco: { name: ('shell.theme.' + mode | transloco) }"
      (click)="toggleThemeMenu($event)">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="themeIcon"></path></svg>
    </button>
    <div *ngIf="themeMenu" class="hd__pop" role="menu">
      <button *ngFor="let m of modes" type="button" role="menuitemradio" class="hd__pop-item" [class.is-on]="m === mode" [attr.aria-checked]="m === mode" (click)="setMode(m)">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="m === 'dark' ? icon.moon : m === 'system' ? icon.auto : icon.sun"></path></svg>
        <span class="hd__grow">{{ 'shell.theme.' + m | transloco }}</span>
        <svg *ngIf="m === mode" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.check"></path></svg>
      </button>
      <span class="hd__pop-note">{{ 'shell.theme.note' | transloco }}</span>
    </div>
  </div>

  <app-shell-notifications></app-shell-notifications>
</header>
